module.exports = new __parcel__URL__("mailgun-logo.ab2e3762.png").toString();